import {
    useCustomerUtilityBillFilePdfPreviewQuery,
    useDownloadCustomerUtilityBillFilePdfMutation,
} from 'src/domain/customer-utility-bill-file/queries';
import { PdfPreviewPanel } from '../../PdfPreviewPanel';

interface Props {
    fileId: string;
}

// Shows the source file PDF straight from S3 via a short-lived, pre-signed URL (404 -> not downloaded yet).
export const BillFilePdfPanel = ({ fileId }: Props) => {
    const { data: pdfUrl, isLoading, isError } = useCustomerUtilityBillFilePdfPreviewQuery(fileId);
    const { mutate: downloadPdf, isLoading: isDownloading } = useDownloadCustomerUtilityBillFilePdfMutation();

    return (
        <PdfPreviewPanel
            pdfUrl={pdfUrl}
            isLoading={isLoading}
            isError={isError}
            onDownload={() => downloadPdf(fileId)}
            isDownloading={isDownloading}
            title="Utility Bill File PDF"
            errorText="Could not load the file PDF"
            emptyText="No PDF available for this file (not downloaded yet)"
        />
    );
};
